import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  getApiWithoutAuthorization,
  postApiWithAuthorization,
  postApiWithoutAuthorization,
} from "../ApiMethod/ApiMethod";

const Templeurl = `${NewUpdatedBaseUrl}/Temple`;

export const GetTempleCityList = async (AppLangID) => {
  const url = `${Templeurl}/GetTempleCityList?AppLangID=${AppLangID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};

// export const GetTempleList = async (DistrictID, languageID) => {
//   let url = null
//   if (DistrictID === null || DistrictID === undefined || DistrictID === "") {
//     url = `${Templeurl}/GetTempleByDistrictList?DistrictID=&AppLangID=${languageID}`;
//   } else {
//     url = `${Templeurl}/GetTempleByDistrictList?DistrictID=${DistrictID}&AppLangID=${languageID}`;
//   }

//   const res = await getApiWithAuthorization(url);
//   return res;
// };
export const GetTempleList = async (bodyData) => {

  const url = `${Templeurl}/GetTempleByDistrictList`;
  const res = await postApiWithAuthorization(url, bodyData);
  return res;
};


export const GetTempleDetailsBySlugList = async (Slug, LangID) => {
  const url = `${Templeurl}/GetTempleDetailsBySlugList?Slug=${Slug}&AppLangID=${LangID || ""}`;
  const res = await getApiWithAuthorization(url);
  return res;
};
export const TempleLookUpList = async (Slug) => {
  const url = `${Templeurl}/TempleLookUpList`;
  const res = await getApiWithAuthorization(url);
  return res;
};